export default "__VITE_ASSET__BhdSeeBs__"